<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <h6 class="text-muted text-uppercase small mb-2">General Information</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="job">Job Site</label>
                    <wj-combo-box
                        [(ngModel)]="target.job"
                        name="job"
                        id="job"
                        [itemsSource]="jobList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="incidentDateTime">Date &amp; Time of Incident</label>
                    <wj-input-date-time
                        [(ngModel)]="target.incidentDateTime"
                        name="incidentDateTime"
                        id="incidentDateTime"
                        [isRequired]="false"
                    ></wj-input-date-time>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="partiesInvolved">Parties Involved</label>
                    <app-voice-text-field
                        [(ngModel)]="target.partiesInvolved"
                        name="partiesInvolved"
                        inputId="partiesInvolved"
                        [rows]="2"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="description">Near Miss Description</label>
                    <app-voice-text-field
                        [(ngModel)]="target.description"
                        name="description"
                        inputId="description"
                        [rows]="3"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="interviewFacts">Facts of the interviews</label>
                    <app-voice-text-field
                        [(ngModel)]="target.interviewFacts"
                        name="interviewFacts"
                        inputId="interviewFacts"
                        [rows]="3"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="correctiveAction">Corrective Action to Take</label>
                    <app-voice-text-field
                        [(ngModel)]="target.correctiveAction"
                        name="correctiveAction"
                        inputId="correctiveAction"
                        [rows]="3"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="employeeSignature">Full Signature</label>
                    <input
                        type="text"
                        class="form-control"
                        id="employeeSignature"
                        name="employeeSignature"
                        [(ngModel)]="target.employeeSignature"
                    />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="signedOn">Signed On</label>
                    <wj-input-date-time [(ngModel)]="target.signedOn" name="signedOn" id="signedOn" [isRequired]="false"></wj-input-date-time>
                </div>
            </div>
        </div>

        @if (target.imageUrls && target.imageUrls.length > 0) {
            <div class="row">
                <label>Attachments</label>
                @for (url of target.imageUrls; let i = $index; track i + '|' + url) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <img
                            style="max-width: 250px; cursor: pointer"
                            [src]="getExistingFileSrc(url)"
                            (click)="openExistingFile(url)"
                            alt=""
                        />
                        <div class="small text-muted mt-1">{{ displayFileName(i) }}</div>
                    </div>
                }
            </div>
        }
        @if (attachments && attachments.length > 0) {
            <div class="row">
                <label>Files To Upload</label>
                @for (file of attachments; track file) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <div class="close-x" (click)="removeAttachment(file)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <img style="width: 100%" [src]="getPendingFileSrc(file)" />
                        <div class="small text-muted mt-1">{{ file.name }}</div>
                    </div>
                }
            </div>
        }
        @if (progress > 0 && progress < 100) {
            <div class="row">
                <div class="col-12">
                    <div class="progress">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            [ngStyle]="{ 'width.%': progress }"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {{ progress }}%
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" style="margin-right: auto" (click)="fileInput.click()">Upload Photos / Documents</button>
        <input
            style="display: none"
            type="file"
            (change)="onFileChanged($event)"
            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
            #fileInput
            multiple
        />
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
